import { render } from "./DownloadWidget.vue?vue&type=template&id=6906c8a6"
import script from "./DownloadWidget.vue?vue&type=script&lang=js"
export * from "./DownloadWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__